// Packages
import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
// Views
import App from "./App";

// Store

//Styles
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import "./component/custom.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Extra Need to Remove
import reportWebVitals from "./reportWebVitals";
import registerServiceWorker from "./registerServiceWorker";
import { persistor, store } from "./Redux/Store";

render(
  <BrowserRouter basename="/">
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

reportWebVitals();
registerServiceWorker();
